/* Itsy Bitsy Boo: shop upgrades. Slide-out bag, sticky add bar, quick add, size filter, delivery estimate. */
(function () {
  'use strict';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var isCartPage = /\/cart\/?$/.test(location.pathname);
  var fmt = function (cents) {
    try { return new Intl.NumberFormat('en-GB', { style: 'currency', currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP' }).format(cents / 100); }
    catch (e) { return '£' + (cents / 100).toFixed(2); }
  };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var img = function (src, w) {
    if (!src) return '';
    try { var u = new URL(src, location.href); u.searchParams.set('width', w || 200); return u.toString(); } catch (e) { return src; }
  };
  var fbag = document.querySelector('[data-boo-fbag]'), fbagCount = fbag ? Number((fbag.querySelector('[data-cart-count]') || {}).textContent || 0) : 0;
  var updateFbag = function () {
    if (!fbag) return;
    var raised = !!document.querySelector('.bh-sticky.visible, .boo-sticky-atc.is-on');
    fbag.hidden = fbagCount < 1;
    fbag.classList.toggle('is-on', fbagCount > 0 && (window.scrollY > 140 || window.innerWidth > 760));
    fbag.classList.toggle('is-raised', raised);
  };
  var setCount = function (n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; });
    if (fbag) {
      var grew = n > fbagCount; fbagCount = n;
      fbag.setAttribute('aria-label', 'Open your bag (' + n + (n === 1 ? ' item)' : ' items)'));
      updateFbag();
      if (grew) { fbag.classList.remove('is-bump'); void fbag.offsetWidth; fbag.classList.add('is-bump'); }
    }
  };
  if (fbag) {
    var fbPend = false;
    window.addEventListener('scroll', function () { if (!fbPend) { fbPend = true; requestAnimationFrame(function () { fbPend = false; updateFbag(); }); } }, { passive: true });
    window.addEventListener('resize', updateFbag);
    setTimeout(updateFbag, 300);
  }

  /* ---------- Delivery estimate: 7 to 10 working days, skipping weekends and bank holidays ---------- */
  var HOLIDAYS = ['2026-12-25', '2026-12-28', '2027-01-01', '2027-03-26', '2027-03-29', '2027-05-03', '2027-05-31', '2027-08-30', '2027-12-27', '2027-12-28'];
  var iso = function (d) { return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0'); };
  var addWorkingDays = function (from, n) {
    var d = new Date(from.getFullYear(), from.getMonth(), from.getDate()), c = 0;
    while (c < n) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6 && HOLIDAYS.indexOf(iso(d)) === -1) c++; }
    return d;
  };
  var day = function (d, withMonth) {
    var wd = d.toLocaleDateString('en-GB', { weekday: 'short' }), m = d.toLocaleDateString('en-GB', { month: 'short' });
    return wd + ' ' + d.getDate() + (withMonth ? ' ' + m : '');
  };
  var etaText = function () {
    var now = new Date(), a = addWorkingDays(now, 7), b = addWorkingDays(now, 10);
    return a.getMonth() === b.getMonth() ? day(a) + ' – ' + day(b, true) : day(a, true) + ' – ' + day(b, true);
  };
  var fillEta = function (scope) { (scope || document).querySelectorAll('[data-boo-eta]').forEach(function (el) { el.textContent = etaText(); }); };
  fillEta();

  /* ---------- Size helpers (same buckets as the homepage age filter) ---------- */
  var cmOf = function (s) {
    var m = s.match(/(\d{2,3})\s?cm/i); if (m) return +m[1];
    m = s.match(/size\s?(\d{2,3})/i); if (m) return +m[1];
    m = s.match(/(\d+)\s*(?:[–-]|to)\s*(\d+)\s*m(?:onths?)?\b/i); if (m) { var hi = +m[2]; return hi <= 3 ? 59 : hi <= 6 ? 66 : hi <= 9 ? 73 : hi <= 12 ? 80 : 90; }
    m = s.match(/(\d+)\s*[–-]\s*(\d+)\s*years?/i); if (m) return 80 + (+m[2]) * 10;
    return null;
  };
  var bucket = function (cm) { return cm <= 70 ? '0-6' : cm <= 80 ? '6-12' : cm <= 90 ? '1-2' : cm <= 100 ? '2-3' : '3+'; };
  var AGE_LABELS = { '0-6': '0–6 months', '6-12': '6–12 months', '1-2': '1–2 years', '2-3': '2–3 years', '3+': '3 years+' };

  /* ---------- Slide-out bag ---------- */
  var bd = document.querySelector('[data-bd]');
  var products = [];
  try { products = (JSON.parse((document.querySelector('[data-bd-products]') || {}).textContent || '[]') || []).filter(Boolean); } catch (e) { products = []; }
  var byHandle = {}; products.forEach(function (p) { byHandle[p.h] = p; });

  var SUGGEST = {
    'bumble-buddy-bee-head-cushion': { kicker: 'Pairs well with it', title: 'Add a Bumble Buddy for first steps', blurb: 'A soft bee head cushion your baby wears like a tiny backpack while learning to sit, crawl and walk.' },
    'hoot-buddy-owl-head-cushion': { kicker: 'Pairs well with it', title: 'Add a Hoot Buddy for first steps', blurb: 'A soft, breathable owl head cushion for wobbly sits, crawls and first steps.' },
    'little-reindeer-christmas-cloak': { kicker: 'Pop a cloak over it', title: 'Little Reindeer Christmas Cloak', blurb: 'A festive cloak they can wear over any outfit. Perfect for Christmas photos.' },
    'little-croc-fluffy-hooded-onesie': { kicker: 'Complete the look', title: 'Little Croc Fluffy Hooded Onesie', blurb: 'Super soft and fluffy, with a character hood. Cosy for chilly days.' },
    'little-deer-hooded-winter-onesie': { kicker: 'Complete the look', title: 'Little Deer Hooded Winter Onesie', blurb: 'A cosy, fluffy deer onesie for winter walks and photos.' },
    'little-snowflake-christmas-romper': { kicker: 'Cosy under a cloak', title: 'Little Snowflake Christmas Romper', blurb: 'A soft red snowflake romper that looks lovely under a cloak.' }
  };
  var kindOf = function (handle, type) {
    var t = (type || '').toLowerCase(), h = handle || '';
    if (t.indexOf('essential') > -1 || h.indexOf('head-cushion') > -1) return 'cushion';
    if (/cloak|cape/.test(t) || /cloak|cape/.test(h)) return 'cloak';
    if (/halloween|spider|bat/.test(t + ' ' + h)) return 'halloween';
    return 'outfit';
  };
  var CANDIDATES = {
    cushion: ['little-croc-fluffy-hooded-onesie', 'little-deer-hooded-winter-onesie', 'little-snowflake-christmas-romper'],
    cloak: ['bumble-buddy-bee-head-cushion', 'little-snowflake-christmas-romper', 'hoot-buddy-owl-head-cushion'],
    halloween: ['bumble-buddy-bee-head-cushion', 'hoot-buddy-owl-head-cushion'],
    outfit: ['bumble-buddy-bee-head-cushion', 'little-reindeer-christmas-cloak', 'hoot-buddy-owl-head-cushion']
  };

  var cart = null, lastAdded = null, skipUntil = 0, leaving = false, lastFocus = null;
  window.addEventListener('beforeunload', function () { leaving = true; });
  document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[data-buy-now]')) skipUntil = Date.now() + 5000; }, true);

  var getCart = function () { return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); };

  function renderSuggest() {
    var box = bd.querySelector('[data-bd-suggest]');
    if (!cart || !cart.items.length) { box.hidden = true; return; }
    var ref = (lastAdded && lastAdded[0]) || cart.items[0];
    var kind = kindOf(ref.handle, ref.product_type);
    var inCart = cart.items.map(function (i) { return i.handle; });
    var pick = null;
    (CANDIDATES[kind] || []).some(function (h) { var p = byHandle[h]; if (p && p.a && inCart.indexOf(h) === -1 && h !== ref.handle) { pick = p; return true; } return false; });
    if (!pick) { box.hidden = true; return; }
    var copy = SUGGEST[pick.h] || { kicker: 'You might also like', title: pick.t, blurb: '' };
    box.innerHTML =
      '<p class="bd-suggest-kicker">' + esc(copy.kicker) + '</p>' +
      '<div class="bd-suggest-row"><a href="' + esc(pick.u) + '" tabindex="-1" aria-hidden="true"><img src="' + esc(img(pick.img, 200)) + '" alt="" width="72" height="72" loading="lazy"></a>' +
      '<div><strong>' + esc(copy.title) + '</strong><small>' + esc(copy.blurb) + '</small></div></div>' +
      '<div class="bd-suggest-act"><b>' + (pick.multi ? 'From ' : '') + esc(fmt(pick.p)) + '</b>' +
      (pick.multi ? '<a href="' + esc(pick.u) + '">Choose size</a>' : '<button type="button" data-quick-add="' + pick.v + '">Add to bag</button>') + '</div>';
    box.hidden = false;
  }

  function render() {
    if (!bd || !cart) return;
    var list = bd.querySelector('[data-bd-items]');
    bd.querySelector('[data-bd-count]').textContent = cart.item_count ? '(' + cart.item_count + ')' : '';
    bd.querySelector('[data-bd-foot]').hidden = !cart.item_count;
    if (!cart.items.length) {
      list.innerHTML = '<li class="bd-empty"><p>Your bag is empty.</p><a href="' + root + 'collections/all">Start shopping</a></li>';
    } else {
      list.innerHTML = cart.items.map(function (it) {
        var name = String(it.product_title || '').split(' | ')[0];
        var variant = it.variant_title && !/default title/i.test(it.variant_title) ? it.variant_title : '';
        return '<li class="bd-item" data-key="' + esc(it.key) + '">' +
          '<a href="' + esc(it.url) + '" tabindex="-1" aria-hidden="true">' + (it.image ? '<img src="' + esc(img(it.image, 200)) + '" alt="" width="76" height="76" loading="lazy">' : '') + '</a>' +
          '<div><a href="' + esc(it.url) + '">' + esc(name) + '</a>' + (variant ? '<small>' + esc(variant) + '</small>' : '') +
          '<div class="bd-qty"><button type="button" data-bd-step="-1" aria-label="Decrease quantity">−</button><span aria-live="polite">' + it.quantity + '</span><button type="button" data-bd-step="1" aria-label="Increase quantity">+</button></div>' +
          '<button type="button" class="bd-remove" data-bd-remove>Remove</button></div>' +
          '<span class="bd-line-price">' + esc(fmt(it.final_line_price)) + '</span></li>';
      }).join('');
    }
    bd.querySelector('[data-bd-total]').textContent = fmt(cart.total_price);
    setCount(cart.item_count);
    renderSuggest();
    fillEta(bd);
  }

  function openDrawer(added) {
    if (!bd) { location.href = root + 'cart'; return; }
    lastAdded = added && added.length ? added : lastAdded;
    var banner = bd.querySelector('[data-bd-added]');
    banner.hidden = !(added && added.length);
    if (added && added.length) banner.textContent = '✓ ' + (added.length === 1 ? String(added[0].product_title || 'Item').split(' | ')[0] + ' added to your bag' : 'Added to your bag');
    lastFocus = document.activeElement;
    bd.hidden = false;
    document.documentElement.classList.add('bd-lock');
    document.body.classList.add('bd-open');
    requestAnimationFrame(function () { bd.classList.add('is-open'); });
    bd.classList.add('is-busy');
    getCart().then(function (c) { cart = c; render(); }).catch(function () {}).then(function () {
      bd.classList.remove('is-busy');
      var x = bd.querySelector('.bd-x'); if (x) x.focus({ preventScroll: true });
    });
  }
  function closeDrawer() {
    if (!bd || bd.hidden) return;
    bd.classList.remove('is-open');
    document.documentElement.classList.remove('bd-lock');
    document.body.classList.remove('bd-open');
    setTimeout(function () { bd.hidden = true; }, 320);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  window.BooBag = { open: openDrawer, close: closeDrawer };
  if (fbag) fbag.addEventListener('click', function () { openDrawer(null); });

  if (bd) {
    bd.addEventListener('click', function (e) {
      if (e.target.closest('[data-bd-close]')) { e.preventDefault(); closeDrawer(); return; }
      var line = e.target.closest('[data-key]');
      var step = e.target.closest('[data-bd-step]'), rem = e.target.closest('[data-bd-remove]');
      if (line && (step || rem)) {
        var item = cart.items.filter(function (i) { return i.key === line.dataset.key; })[0];
        if (!item) return;
        var q = rem ? 0 : Math.max(0, Math.min(10, item.quantity + Number(step.dataset.bdStep)));
        bd.classList.add('is-busy');
        fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: item.key, quantity: q }) })
          .then(function (r) { return r.json(); })
          .then(function (c) { if (c && c.items) { cart = c; bd.querySelector('[data-bd-added]').hidden = true; render(); } })
          .catch(function () {})
          .then(function () { bd.classList.remove('is-busy'); });
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
  }

  /* Open the bag from the header "Bag" link (except on the bag page itself). */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a.boo-bag');
    if (!a || isCartPage || !bd || e.metaKey || e.ctrlKey || e.shiftKey) return;
    e.preventDefault(); openDrawer(null);
  });

  /* Open the bag after anything is added (product page, homepage quick add, pairs, suggestions). */
  var nativeFetch = window.fetch;
  if (nativeFetch && bd && !isCartPage) {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      var p = nativeFetch.apply(this, arguments);
      if (method === 'POST' && /\/cart\/add(\.js)?(\?|$)/.test(url)) {
        p.then(function (res) {
          if (!res.ok) return;
          res.clone().json().then(function (d) {
            var items = d && d.items ? d.items : d && d.id ? [d] : [];
            setTimeout(function () {
              if (leaving || Date.now() < skipUntil) return;
              var sheetClose = document.querySelector('[data-bh-sheet]:not([hidden]) [data-bh-close]');
              if (sheetClose) sheetClose.click();
              openDrawer(items);
            }, 90);
          }).catch(function () {});
        }).catch(function () {});
      }
      return p;
    };
  }

  /* Quick add buttons ("Pairs well with" and bag suggestions). */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-quick-add]');
    if (!b) return;
    e.preventDefault();
    var label = b.textContent;
    b.disabled = true; b.textContent = 'Adding…';
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(b.dataset.quickAdd), quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw new Error(); if (!bd || isCartPage) location.href = root + 'cart'; })
      .catch(function () { b.textContent = 'Try again'; setTimeout(function () { b.textContent = label; }, 1800); })
      .then(function () { b.disabled = false; if (b.textContent === 'Adding…') b.textContent = label; });
  });

  /* ---------- Sticky add-to-bag bar on phones ---------- */
  (function () {
    var form = document.querySelector('[data-boo-product] [data-product-form]');
    if (!form || !('IntersectionObserver' in window)) return;
    var add = form.querySelector('[data-add]'), row = form.querySelector('.boo-purchase-row') || add;
    if (!add) return;
    var titleEl = document.querySelector('.boo-pdp-title'), priceEl = document.querySelector('[data-boo-product] [data-price]');
    var bar = document.createElement('div');
    bar.className = 'boo-sticky-atc'; bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = '<div class="boo-sticky-atc-info"><strong></strong><span></span></div><button type="button" tabindex="-1"></button>';
    document.body.appendChild(bar);
    document.body.classList.add('has-sticky-atc');
    var btn = bar.querySelector('button');
    var sync = function () {
      bar.querySelector('strong').textContent = titleEl ? titleEl.textContent.trim() : '';
      var bits = [];
      if (priceEl) bits.push(priceEl.textContent.trim());
      form.querySelectorAll('[data-option]').forEach(function (fs) { if (fs.hidden) return; var v = fs.querySelector('[data-option-value]'); if (v && v.textContent.trim()) bits.push(v.textContent.trim()); });
      bar.querySelector('span').textContent = bits.join(' · ');
      btn.disabled = add.disabled;
      btn.textContent = add.textContent.trim() || 'Add to bag';
    };
    sync();
    form.addEventListener('change', function () { setTimeout(sync, 0); });
    new MutationObserver(sync).observe(add, { attributes: true, childList: true, characterData: true, subtree: true });
    if (priceEl) new MutationObserver(sync).observe(priceEl, { childList: true, characterData: true, subtree: true });
    btn.addEventListener('click', function () { if (add.disabled) return; if (form.requestSubmit) form.requestSubmit(add); else add.click(); });
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { var show = !en.isIntersecting && en.boundingClientRect.top < 0; bar.classList.toggle('is-on', show); bar.setAttribute('aria-hidden', String(!show)); btn.tabIndex = show ? 0 : -1; });
    }, { threshold: 0 }).observe(row);
  })();

  /* ---------- Collection size filter ---------- */
  (function () {
    var barEl = document.querySelector('[data-boo-sizebar]');
    if (!barEl) return;
    var items = [].slice.call(document.querySelectorAll('[data-sizes]'));
    items.forEach(function (li) {
      var ages = {}, list = (li.getAttribute('data-sizes') || '').split('|').filter(Boolean);
      list.forEach(function (s) { var cm = cmOf(s); if (cm) ages[bucket(cm)] = 1; });
      if (!Object.keys(ages).length) { ages['6-12'] = 1; ages['1-2'] = 1; }
      li._ages = ages;
    });
    var countEl = barEl.querySelector('[data-boo-sizebar-count]'), empty = document.querySelector('[data-boo-sizebar-empty]');
    var set = function (age) {
      barEl.querySelectorAll('button[data-age]').forEach(function (b) { var on = b.dataset.age === age; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', String(on)); });
      var n = 0;
      items.forEach(function (li) { var show = age === 'all' || li._ages[age]; li.hidden = !show; if (show) n++; });
      if (empty) empty.hidden = n > 0;
      if (countEl) countEl.textContent = age === 'all' ? '' : n + (n === 1 ? ' style' : ' styles') + ' for ' + AGE_LABELS[age];
    };
    barEl.addEventListener('click', function (e) { var b = e.target.closest('button[data-age]'); if (b) set(b.dataset.age); });
  })();
})();
